import { render } from "./TermsOfServiceView.vue?vue&type=template&id=403cb2ce&scoped=true"
const script = {}

import "./TermsOfServiceView.vue?vue&type=style&index=0&id=403cb2ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403cb2ce"]])

export default __exports__